

























































import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';

export default {
    name: 'PasswordStep',
    components: {
        CoButton,
        CoFormGroup,
        CoInput,
        CoText,
    },
    props: {
        allowPasswordless: {
            type: Boolean,
            default: false,
        },
        email: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            password: '',
        };
    },
    methods: {
        submit() {
            this.$emit('submit', this.password);
        },
    },
};
